<template>
  <div class="home_container">
    <!-- <page-top></page-top> -->
    <my-swiper :list="(_i18n.locale=='zh'?loopList:loopListEn)" ref="topSwiper"></my-swiper>
    <!-- <div class="content_wrap"> -->
    <expo-msg ref="contentRef"></expo-msg>
    <!-- </div> -->
    <!-- <page-bottom></page-bottom> -->
     <!-- 右侧浮窗挂一个公众号二维码，固定定位 -->
      <!-- <div class="right_float">
        <div>
          <img src="https://faststatic.ccnfgame.com/cos/vrshow/autoAv/link.png" alt="">
        </div>
        <h3 @click="handelClick()">{{$t('homepage.professionalPreReg')}}</h3>
      </div> -->
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
import pageBottom from "@/components/pageBottom";
import pageFooter from "@/components/pageFooter";
import mySwiper from "@/components/mySwiper";
import expoMsg from "./expoMsg";
export default {
  components: {
    pageTop,
    pageBottom,
    mySwiper,
    expoMsg,
    pageFooter,
  },
  mounted() {
    // console.log(this.$route.query);
    let showHotel = localStorage.getItem("showHotel");
    localStorage.setItem("showHotel", this.$route.query.showHotel || showHotel);
    console.log(this._i18n.locale);
    
  },
  data() {
    return {
      loopListEn:[
      {
          id: "9",
          img: require("../../assets/img/banner7.jpg"),
        },
      ],
      loopList: [
        {
          id: "11",
          img: require("../../assets/img/banner5.jpg"),
        },
        // {
        //   id: "10",
        //   img: require("../../assets/img/banner6.jpg"),
        // },
        {
          id: "9",
          img: require("../../assets/img/banner4.jpg"),
        },

        // {
        //   id: "12",
        //   img: require("../../assets/img/banner2.png")
        // },
        // {
        //   id: "22",
        //   img: require("../../assets/img/banner1.png")
        // }
      ],
    };
  },
  methods: {
    handelClick() {
      window.open("https://ap.autoguangzhou.com.cn/#/hregister?r=si38k5320v&n=OFFICIALWEBSITE", "_blank");
    }
  },
};
</script>

<style lang="scss">
.home_container {
  width: 100vw;
  // height: 2000px;
  // min-height: 100vh;
  background: #221f26;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: space-between;

  .content_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .right_float {
    position: fixed;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 180px;
    height: 180px;
    border-radius: 50px;
    justify-content: center;
    align-items: center;
    z-index: 99900;
    div {
      background: linear-gradient(#0d74eb 0%, #0f38a9 100%), #0e4bbe;      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
    }
    h3 {
      font-size: 18px;
      background: #0E4BBE;
      color: #fff;
      margin-top: 10px;
      padding: 10px 10px;
      box-sizing: border-box;
      border: 2px solid #0E4BBE;
      cursor: pointer;
      text-align: center;
    }
  }
}

@media screen and (max-width: 1000px) {
  .menu_wrap {
    .right_wrap {
      visibility: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?55169cba